<div class="custom-card-body tab-lines">

    <ng-container *ngIf="package && 'Pages.App.Webshop.View.ShowPalletsInfo' | permission">
        <app-pallets></app-pallets>
    </ng-container>


    <div class="row">
        <div class="col-lg-12">
            <div class="primeng-datatable-container products">
                <p-table #dataTable
                         [lazy]="true"
                         (onLazyLoad)="getBasket($event)"
                         [value]="primengTableHelper.records"
                         rows="{{primengTableHelper.defaultRecordsCountPerPage}}"
                         [responsive]="primengTableHelper.isResponsive"
                         [resizableColumns]="primengTableHelper.resizableColumns">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 10em">
                                <span translation="Axilla.OrderGuide.Article.Picture" source="Axilla">
                                </span>
                            </th>
                            <th pSortableColumn="code" style="width: 10em">
                                <span translation="Axilla.OrderGuide.Article.Code" source="Axilla">
                                </span>
                                <p-sortIcon field="code"></p-sortIcon>
                            </th>
                            <th pSortableColumn="title">
                                <span translation="Axilla.OrderGuide.Article.Title" source="Axilla">
                                </span>
                                <p-sortIcon field="title"></p-sortIcon>
                            </th>

                            <th pSortableColumn="description">
                                <span translation="Axilla.OrderGuide.Article.Description" source="Axilla">
                                </span>
                                <p-sortIcon field="description"></p-sortIcon>
                            </th>
                            <th style="width: 5em; text-align: right">
                                <span translation="Axilla.OrderGuide.Article.ItemAmount" source="Axilla">
                                </span>
                            </th>
                            <th style="width: 7em">
                                <span translation="Axilla.OrderGuide.Article.ItemPackage" source="Axilla">
                                </span>
                            </th>
                            <th pSortableColumn="price" style="width: 6em">
                                <span translation="Axilla.OrderGuide.Article.Price" source="Axilla">
                                </span>
                                <p-sortIcon field="price"></p-sortIcon>
                            </th>
                            <th style="width: 8em;">
                                <span translation="Axilla.OrderGuide.Article.Count" source="Axilla">
                                </span>
                            </th>

                            <th style="width: 8em;">
                                Total
                                <!--<span translation="Axilla.OrderGuide.Article.Count" source="Axilla"></span>-->
                            </th>

                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-record="$implicit">
                        <tr>
                            <td>
                                <app-image-container [articleId]="record.code" [height]="'68'"></app-image-container>
                            </td>
                            <td>
                                {{record.code}}
                            </td>
                            <td>
                                {{record.title}}
                            </td>

                            <td>
                                <div class="td-overflow">
                                    {{record.description}}
                                </div>
                            </td>
                            <td style="text-align: right">
                                {{record.amount}}
                            </td>
                            <td>
                                <span *ngIf="record.amount == 1" translation="Axilla.OrderGuide.Article.AmountPce" source="Axilla">
                                </span>
                                <span *ngIf="record.amount > 1" translation="Axilla.OrderGuide.Article.AmountBox" source="Axilla">
                                </span>
                            </td>
                            <td>
                                {{record.price | currency:getCurrency(record.currency):'symbol-narrow':'.2-2'}}
                            </td>
                            <td style="width: 150px">
                                {{record.quantity}}
                            </td>
                            <td style="width: 150px">
                                {{record.price * record.quantity | currency:getCurrency(record.currency):'symbol-narrow':'.2-2'}}
                            </td>

                        </tr>
                    </ng-template>


                    <ng-template pTemplate="footer">
                        <tr>
                            <td colspan="8" align="right">Totals</td>
                            <td>{{getBasketTotal() | currency:getCurrency():'symbol-narrow':'.2-2'}}</td>
                        </tr>
                    </ng-template>
                </p-table>

                <div class="primeng-no-data" *ngIf="primengTableHelper.totalRecordsCount == 0 && !primengTableHelper.isLoading && basket.length == 0">
                    <span translation="Axilla.NoData" source="Axilla"></span>
                </div>
                <div class="primeng-no-data" *ngIf="primengTableHelper.isLoading">
                    <span translation="Axilla.LoadingData" source="Axilla"></span>
                </div>

            </div>
        </div>
    </div>

    <div class="row">
        <h4 style="margin: 50px 0 25px">Delivery:</h4>

        <div class="col-lg-12">
            <div class="primeng-datatable-container products">
                <p-table #deliveryDataTable
                         [value]="deliveryPrimengTableHelper.records"
                         rows="{{deliveryPrimengTableHelper.defaultRecordsCountPerPage}}"
                         [responsive]="deliveryPrimengTableHelper.isResponsive"
                         [resizableColumns]="deliveryPrimengTableHelper.resizableColumns">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 10em">
                                Code
                                <!--<span translation="Axilla.OrderGuide.Article.Picture" source="Axilla"></span>-->
                            </th>
                            <th style="width: 10em">
                                Title
                                <!--<span translation="Axilla.OrderGuide.Article.Code" source="Axilla"></span>-->
                            </th>
                            <th>
                                Description
                                <!--<span translation="Axilla.OrderGuide.Article.Description" source="Axilla"></span>-->
                            </th>
                            <th style="width: 8em;">
                                Delivery Date
                                <!--<span translation="Axilla.OrderGuide.Article.DeliveryDate" source="Axilla"></span>-->
                            </th>
                            <th style="width: 8em">
                                Price
                                <!--<span translation="Axilla.OrderGuide.Article.Price" source="Axilla"></span>-->
                            </th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-record="$implicit">
                        <tr>
                            <td>
                                {{record.code}}
                            </td>
                            <td>
                                {{record.title}}
                            </td>

                            <td>
                                <div class="td-overflow">
                                    {{record.description}}
                                </div>
                            </td>
                            <td>
                                {{getDeliveryDate(record.code) | momentFormat:'L'}}
                            </td>
                            <td>
                                {{record.price | currency:record.currency:'symbol-narrow':'.2-2'}}
                            </td>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="footer">
                        <tr>
                            <td colspan="4" align="right">Totals</td>
                            <td>{{getDeliveryTotal() | currency:getCurrency():'symbol-narrow':'.2-2'}}</td>
                        </tr>
                    </ng-template>
                </p-table>
                <div class="primeng-no-data" *ngIf="deliveryPrimengTableHelper.isLoading">
                    <span translation="Axilla.LoadingData" source="Axilla"></span>
                </div>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="ifAdditionalPRopertiesAvailable()">
        <h4 style="margin: 50px 0 25px">Additional Articles:</h4>

        <div class="col-lg-12">
            <div class="primeng-datatable-container products">
                <p-table #additionalArticleDataTable
                         [value]="additionalArticlePrimengTableHelper.records"
                         rows="{{additionalArticlePrimengTableHelper.defaultRecordsCountPerPage}}"
                         [responsive]="additionalArticlePrimengTableHelper.isResponsive"
                         [resizableColumns]="additionalArticlePrimengTableHelper.resizableColumns">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 10em">
                                <span translation="Axilla.OrderGuide.Article.Picture" source="Axilla">
                                </span>
                            </th>
                            <th pSortableColumn="code" style="width: 10em">
                                <span translation="Axilla.OrderGuide.Article.Code" source="Axilla">
                                </span>
                                <p-sortIcon field="code"></p-sortIcon>
                            </th>
                            <th pSortableColumn="title">
                                <span translation="Axilla.OrderGuide.Article.Title" source="Axilla">
                                </span>
                                <p-sortIcon field="title"></p-sortIcon>
                            </th>

                            <th pSortableColumn="description">
                                <span translation="Axilla.OrderGuide.Article.Description" source="Axilla">
                                </span>
                                <p-sortIcon field="description"></p-sortIcon>
                            </th>
                            <th style="width: 5em; text-align: right">
                                <span translation="Axilla.OrderGuide.Article.ItemAmount" source="Axilla">
                                </span>
                            </th>
                            <th pSortableColumn="price" style="width: 6em">
                                <span translation="Axilla.OrderGuide.Article.Price" source="Axilla">
                                </span>
                                <p-sortIcon field="price"></p-sortIcon>
                            </th>
                            <th style="width: 8em;">
                                <span translation="Axilla.OrderGuide.Article.Count" source="Axilla">
                                </span>
                            </th>

                            <th style="width: 8em;">
                                Total
                                <!--<span translation="Axilla.OrderGuide.Article.Count" source="Axilla"></span>-->
                            </th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-record="$implicit">
                        <tr>
                            <td>
                                <app-image-container [articleId]="record.code" [height]="'68'"></app-image-container>
                            </td>
                            <td>
                                {{record.code}}
                            </td>
                            <td>
                                {{record.title}}
                            </td>

                            <td>
                                <div class="td-overflow">
                                    {{record.description}}
                                </div>
                            </td>
                            <td style="text-align: right">
                                {{record.amount}}
                            </td>

                            <td>
                                {{record.price | currency:record.currency:'symbol-narrow':'.2-2'}}
                            </td>
                            <td style="width: 150px">
                                {{record.quantity}}
                            </td>
                            <td style="width: 150px">
                                {{record.price * record.quantity | currency:record.currency:'symbol-narrow':'.2-2'}}
                            </td>
                        </tr>
                    </ng-template>


                    <ng-template pTemplate="footer">
                        <tr>
                            <td colspan="7" align="right">Totals</td>
                            <td>{{getDocumentTotal() | currency:getCurrency():'symbol-narrow':'.2-2'}}</td>
                        </tr>
                    </ng-template>
                </p-table>
                <div class="primeng-no-data" *ngIf="additionalArticlePrimengTableHelper.isLoading">
                    <span translation="Axilla.LoadingData" source="Axilla"></span>
                </div>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="ifAgreementsAvailable()">
        <h4 style="margin: 50px 0 25px">Agreements:</h4>

        <div class="col-lg-12">
            <app-confirm-order-terms-and-conditions style="flex: 1"
                                                     [agreements]="agreements"
                                                     [readonly]="true"
                                                     (acceptAgreement)="acceptAgreement($event)">
            </app-confirm-order-terms-and-conditions>
        </div>
    </div>

    <div class="row"  style="margin: 50px 0 25px">
        <div class="d-flex justify-content-end" style="font-size: 1.8em; flex: 1">
            <strong>Total:</strong> &nbsp;&nbsp;{{total | currency:getCurrency():'symbol-narrow':'.2-2'}}
        </div>
    </div>
</div>
